import { SimilarInfluencersTemplate, WidgetSelectButtonProps } from '../../shared';
import { RefetchSimilarInfluencersVariables } from '../../schemaTypes';
import { useInstagramSimilarInfluencersList } from '../hooks';
import { InstagramInfluencerProfile } from '../schemaTypes';
import { ProfileWidget } from './ProfileWidget';

interface SimilarInfluencersListProps {
  socialAccountId: string;
  getListSelectButtonProps?: (influencer: InstagramInfluencerProfile) => WidgetSelectButtonProps;
  isSectionOpened: boolean;
}

export const SimilarInfluencersList = ({
  socialAccountId,
  isSectionOpened,
  getListSelectButtonProps
}: SimilarInfluencersListProps) => {
  const { limit, loading, totalRecords, listRecords, onFetchData, onRefetchData } = useInstagramSimilarInfluencersList({
    socialAccountId
  });

  const handleRefetchData = async (variables: RefetchSimilarInfluencersVariables) => {
    await onRefetchData?.(variables);
  };

  return (
    <SimilarInfluencersTemplate
      loading={loading}
      fetchLimit={limit}
      onFetchData={onFetchData}
      totalRecords={totalRecords}
      onRefetchData={handleRefetchData}
      isSectionOpened={isSectionOpened}
    >
      {({ currentLimit }) =>
        listRecords
          .slice(0, currentLimit)
          .map((profile, index) => (
            <ProfileWidget
              profile={profile}
              key={`similar-influencer-${profile.id}_${index}`}
              selectButtonProps={getListSelectButtonProps?.(profile)}
              className="bg-black-10 shadow-[none]"
            />
          ))
      }
    </SimilarInfluencersTemplate>
  );
};
